<template>
    <div>
        <div>
            <div class="form-check-label" :style="'border: 2px solid #e4e6e7; padding: 10px; border-radius: 24px'">
                <div class="d-flex align-items-center space-between">
                    <div class="ms-2 w-100">
                        <span class="fw-bold">Stripe</span>
                    </div>

                    <v-menu v-model="menu" :close-on-content-click="false" offset-x left nudge-right="30">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab icon v-bind="attrs" v-on="on">
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </template>
                        <AddNewPaymentCard
                                :userId="userId" v-on:add-new-card="newCardAdded()" v-on:close-modal="closeCardModal()"
                              ></AddNewPaymentCard>

                    </v-menu>
                </div>

                <span style="margin-left: 10px; color: red" v-if="errorPrelever">{{ errorPrelever }}</span>

                <div style="margin-top: 20px" class="d-flex justify-center clientCards">
                    <v-select :items="clientCards" label="Carte de paiment" single-line solo dense hide-details
                        v-model="selectCard"
                        style="max-width: 300px; margin-left: 5px; margin-right: 20px ;postion: absolute;">
                        <template #no-data>
                            <div style="padding: 8px">Aucun résultat</div>
                        </template>
                        <template #item="{ item }">
                            <span> ****-****-****-{{ item.ending }} </span>
                        </template>
                        <template #selection="{ item }">
                            <span> ****-****-****-{{ item.ending }} </span>
                        </template>
                    </v-select>

                    <input type="number" class="form-control form-control-sm disabled" min="1" style="max-width: 5rem;"
                        v-model="amount" />
                    <span style="margin: auto; margin-left: 6px">€</span>
                    <v-btn type="button" style="margin-right: 10px; color: white; font-family: Roboto;border-radius: 24px"
                        :disabled="!selectCard || !amount || amount <= 0" @click="prelever" :loading="loadingPreleve"
                        color="#2F4858">
                        Prélever
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.clientCards .v-input__slot {
    border-radius: 24px;
}
</style>
<script>
import axios from 'axios'

export default {
    props: ['userId', 'orderId'],
    mounted() {

        this.getClientCards()
    },
    components: {
        AddNewPaymentCard: () => import('./AddNewCard.vue'),
    },

    data: () => {
        return {
            menu: false,
            cartNum: null,
            expire: null,
            cvv: null,
            valid: false,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            amount: 0,
            rules: {
                valid_num_cart: value => {
                    const pattern = /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/
                    return pattern.test(value) || 'Format incorect (XXXX-XXXX-XXXX-XXXX)'
                },
                valid_expire: value => {
                    const pattern = /^[0-9]{2}\/[0-9]{2}$/
                    return pattern.test(value) || 'Format incorect (MM/YY)'
                },
                valid_cvv: value => {
                    const pattern = /^[0-9]{3}$/
                    return pattern.test(value) || 'Format incorect (XXX)'
                },
                required: value => !!value || 'Element requis.',
            },
        }
    },
    watch: {
        cartNum(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('-', ''), '-', 4, 3)
            if (newFormat.length > 19) newFormat = newFormat.substring(0, 19)

            if (val === newFormat) return

            this.cartNum = newFormat
        },
        expire(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('/', ''), '/', 2, 1)
            if (newFormat.length > 5) newFormat = newFormat.substring(0, 5)

            if (val === newFormat) return

            this.expire = newFormat
        },
    },
    methods: {
        insertAfterEveryN(str, char, n, res) {
            const result = str.split('').reduce((accumulator, current, index) => {
                if (index % n === res) {
                    return accumulator + current + char
                }

                return accumulator + current
            }, '')

            return result
        },
        async getClientCards() {
            await axios.get(`/back-office/caisse/getPaymentMethod/${this.userId}`).then(res => {
                this.clientCards = res.data
            })
        },
        async prelever() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByStripe`,
                    {
                        montant: this.amount,
                        userId: this.userId,
                        orderId: this.orderId,
                        cartId: this.selectCard.id,
                    },
                    { withCredentials: true }
                )
                .then(() => {
                    window.location.reload()
                })
                .catch(error => {
                    this.errorPrelever = error?.response?.data?.message || 'Une erreur est survenue'
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
        async addClientCard() {
            this.loadingAddCart = true
            await axios
                .post(
                    `/back-office/customer/${this.userId}/payment/updatePaymentMethode`,
                    {
                        card_number: `${this.cartNum}`.replaceAll('-', ''),
                        card_date: `${this.expire}`,
                        card_cvc: `${this.cvv}`,
                    },
                    { withCredentials: true }
                )
                .then(res => {
                    this.menu = false
                    this.getClientCards()
                })
                .finally(() => {
                    this.loadingAddCart = false
                })
        },
        newCardAdded()
        {
            this.getClientCards()
           // this.menu = false
        },
        closeCardModal() {
            this.menu = false;
        },
    },
}
</script>
